import { render } from "./result.vue?vue&type=template&id=ce0beffe&scoped=true"
const script = {}

import "./result.vue?vue&type=style&index=0&id=ce0beffe&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-ce0beffe"

export default script